module.exports = __webpack_public_path__ + "img/jobs.aea0020f.svg";